var version = {
    "name":      "dativery",
    "buildDateCode": "20260729-102115",
    "buildDate": "Wed Jul 29 2026 10:21:15 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260729-102115",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;